<template>
  <div>
    <p>{{ $t('{brand} is on a mission to provide {country} with a lost property solution.', {brand: brandName, country: brandCountry}) }}</p>

    <p>{{ $t('Thank you for playing an important part in this mission and both {brand} and the member who has the lost the item you have found really appreciate you considering helping to return it.', {brand: brandName}) }}</p>

    <p>{{ $t('Our unique returns technology which you are now using is helping people all over the UK get their lost items returned which is leading to financial savings due by not having the expense of replacing lost items and equally if not more importantly making a significant contribution to saving the environment.') }}</p>

    <p>{{ $t('As with everything these days we have to have terms for your protection, our protection and the protection of the {brand} member who has lost their item.', {brand: brandName}) }}</p>

    <p>{{ $t('As a finder of a lost item of a {brand} member you are under no obligation to return the item using our returns technology and our returns programme and if you do participate you do so at your own risk. There is no liability to {brand} or the {brand} member if you participate but do not follow the returns process using the returns technology. you agree and understand you are acting on your own behalf at all times.', {brand: brandName}) }}</p>

    <p>{{ $t('{brand} will never share any of your personal information and in the returns process we simply need you to enter your email address in order for {brand} to allow you to communicate with the owner of the lost item (a {brand} member) via email. Your email address is not stored, is disguised and is never disclosed.', {brand: brandName}) }}</p>

    <p>{{ $t('Our members safety and your safety is our priority and we will never knowingly do anything to compromise personal safety. We have inbuilt safeguarding controls to ensure everyone is safe at all times – these include filters for inappropriate language and images which will be scanned and filtered. You may receive messages that contain colourful language but these will be carefully monitored and only sent to you if the language is in the context of the finding and returning of a lost item. An example my be an expletive in a sentence because the owner is excited and or relieved their item may be returned. If this does occur then our returns technology will blur out the inappropriate words in a way you can still read the sentence. We will never allow anything offensive, suggestive or inappropriate to be sent to you. you also agree to not use inappropriate or suggestive language in the returns process.') }}</p>

    <h2 class="text-h6 mb-2">{{ $t('headings.How it works') }}</h2>

    <ul class="mb-6">
      <li>{{ $t('You have scanned a {brand} smart tag', {brand: brandName}) }}</li>
      <li>{{ $t('You enter the smart tag number into our returns technology') }}</li>
      <li>{{ $t('You have two options') }}
        <ol>
          <li>{{ $t('Send or drop off the item to the address shown on our returns page') }}</li>
          <li>{{ $t('Anonymously email the owner of the item you have found to organise the return of the item') }}</li>
        </ol>
      </li>
      <li>{{ $t('We disguise your email address using a {brand} email temporary address.', {brand: brandName}) }}</li>
      <li>{{ $t('You have an anonymous discussion via email to organise the return of the item') }}</li>
    </ul>

    <h2 class="text-h6 mb-2">{{ $t("headings.Do's and don'ts") }}</h2>

    <ul>
      <li>{{ $t('The safest way is to drop the item off or post the time to the organisation listed on the returns programme page which appears after you have scanned the smart tag.') }}</li>
      <li>{{ $t('If you are unable to return the item to the organisation then we recommend you anonymously email with the owner of the item (they will always be a {brand} member) to organise the return of the item.', {brand: brandName}) }}</li>
      <li>{{ $t('Safety is first and foremost.') }}</li>
      <li>{{ $t('Never organise to meet the owner of the item unless you know them and trust them.') }}</li>
      <li>{{ $t('Never provide your address, business address or any contact details to the owner unless you know them and trust.') }}</li>
      <li>{{ $t('Never return the item to a residential address or any address you are not familiar with and is not in a high street or busy public access area you know is safe.') }}</li>
      <li>{{ $t('If at any stage of the returns process  you feel uncomfortable immediately Stop the process – you can do this on any screen of the process.') }}</li>
      <li>{{ $t('Never engaged in banter or any type of conversation other than organising the return of the item.') }}</li>
    </ul>
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: "FinderTerms",
  computed: {
    ...mapState({
      brand: state => state.brand,
      brandName: state => state.brandName
    }),
    brandCountry() {
      if (this.brand === 'neotag') {
        return 'Spain'
      }
      else {
        return 'the UK'
      }
    }
  }
}
</script>

<style scoped>

</style>
